module.exports = __webpack_public_path__ + "img/icon-24-ic-plus.99927126.svg";